import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './workplace/plugins'
import Rails from '@rails/ujs'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
window.bootstrap = bootstrap

import Turbolinks from 'turbolinks'
import './workplace/application'

import '../stylesheets/workplace/workplace.scss'
import './pages/registration.coffee'

Rails.start()
Turbolinks.start()

if (gon.is_analytics_allowed) {
    import('./workplace/firebase/fireinit')
}

if (gon.uxcam_api_key) {
    import('./shared/uxcam-init')
}

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

window.Rails = Rails
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './workplace/plugins'
import Rails from '@rails/ujs'
import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle'
window.bootstrap = bootstrap

import Turbolinks from 'turbolinks'
import './workplace/application'

import '../stylesheets/workplace/workplace.scss'
import './pages/registration.coffee'

Rails.start()
Turbolinks.start()

if (gon.is_analytics_allowed) {
    import('./workplace/firebase/fireinit')
}

if (gon.uxcam_api_key) {
    import('./shared/uxcam-init')
}

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

window.Rails = Rails
